function MobileMenu() {
    this.trigger = document.querySelector('.jsMobileMenuTrigger');
    this.mobileMenu = document.querySelector('.jsMobileMenu');
    this.menuItems = this.mobileMenu.querySelectorAll('.menu li');
    this.closeBtn = this.mobileMenu.querySelector('.jsMobileMenuCloseBtn');
    this.socialIcons = this.mobileMenu.querySelector('.jsSocialIcons');

    this.mobileMenu.addEventListener('click', e => {
        if (e.target.tagName.toLowerCase() === 'a') this.hideMenu();
    });

    this.trigger.addEventListener('click', e => {
        e.preventDefault();
        this.openMenu();
    });

    this.closeBtn.addEventListener('click', e => {
        e.preventDefault();
        this.hideMenu();
    });

    window.addEventListener('resize', _ => {
        if (window.innerWidth >= 850) {
            document.body.classList.remove('mobile-menu-open');
        }
    });
};

MobileMenu.prototype.openMenu = function() {
    new TimelineMax()
        .set(this.mobileMenu, { display: 'block', opacity: 0 })
        .set(this.menuItems, { y: 15, opacity: 0 })
        .set(this.socialIcons, { y: 15, opacity: 0 })

        .to(this.mobileMenu, 0.6, { opacity: 1, ease: Power2.easeInOut })
        .staggerTo(this.menuItems, 1.2, { y: 0, opacity: 1, ease: Power2.easeOut }, '0.06', '-=0.2')
        .to(this.socialIcons, 0.6, { y: 0, opacity: 1, ease: Power2.easeOut }, '-=1')

        .add(_ => {
            document.body.classList.add('mobile-menu-open');
            TweenLite.set([this.mobileMenu, this.menuItems, this.socialIcons], { clearProps: 'all' });
        })
    ;
};

MobileMenu.prototype.hideMenu = function() {
    new TimelineMax()
        .staggerTo(this.menuItems, 0.6, { y: 15, opacity: 0, ease: Power2.easeOut }, '0.08')
        .to(this.mobileMenu, 0.6, { opacity: 0, ease: Power2.easeInOut }, '-=0.4')
        .to(this.socialIcons, 0.6, { y: 15, opacity: 1, ease: Power2.easeInOut }, '-=0.6')

        .add(_ => {
            document.body.classList.remove('mobile-menu-open');
            TweenLite.set([this.mobileMenu, this.menuItems, this.socialIcons], { clearProps: 'all' });
        });
    ;
};